import React from 'react';
import { Card, Descriptions, Typography, Button, Space, Tag, Avatar, Spin } from 'antd';
import { EditOutlined, ArrowLeftOutlined, UserOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import { useUser } from '@/hooks/useUsers';

const { Title } = Typography;

const UserDetail: React.FC = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: user, isLoading } = useUser(id || '');

  if (isLoading) {
    return <Spin size="large" style={{ display: 'flex', justifyContent: 'center', marginTop: 100 }} />;
  }

  if (!user) {
    return <div>Usuário não encontrado</div>;
  }

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
        <Space>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/users')} />
          <Title level={4} style={{ margin: 0 }}>Detalhes do Usuário</Title>
        </Space>
        <Button
          type="primary"
          icon={<EditOutlined />}
          onClick={() => navigate(`/users/${id}/edit`)}
        >
          Editar
        </Button>
      </div>

      <Card>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 24 }}>
          <Avatar size={64} icon={<UserOutlined />} src={user.avatar} />
          <div style={{ marginLeft: 16 }}>
            <Title level={4} style={{ margin: 0 }}>{user.full_name}</Title>
            <Tag color={
              user.profile === 'SUPER_ADMIN' ? 'red' :
              user.profile === 'ADMIN' ? 'orange' :
              user.profile === 'OPERATOR' ? 'blue' : 'green'
            }>
              {user.profile === 'SUPER_ADMIN' ? 'Super Admin' :
               user.profile === 'ADMIN' ? 'Admin' :
               user.profile === 'OPERATOR' ? 'Operador' : 'Visualizador'}
            </Tag>
          </div>
        </div>

        <Descriptions bordered column={{ xs: 1, sm: 2, lg: 3 }}>
          <Descriptions.Item label="Nome">{user.first_name}</Descriptions.Item>
          <Descriptions.Item label="Sobrenome">{user.last_name}</Descriptions.Item>
          <Descriptions.Item label="E-mail">{user.email}</Descriptions.Item>
          <Descriptions.Item label="Nome de Usuário">{user.username}</Descriptions.Item>
          <Descriptions.Item label="Telefone">{user.phone || '-'}</Descriptions.Item>
          <Descriptions.Item label="Empresa">{user.company_name || '-'}</Descriptions.Item>
          <Descriptions.Item label="Status">
            <Tag color={user.is_active ? 'green' : 'red'}>
              {user.is_active ? 'Ativo' : 'Inativo'}
            </Tag>
          </Descriptions.Item>
          <Descriptions.Item label="Último Acesso">
            {user.last_login ? new Date(user.last_login).toLocaleString('pt-BR') : '-'}
          </Descriptions.Item>
          <Descriptions.Item label="Criado em">
            {new Date(user.created_at).toLocaleString('pt-BR')}
          </Descriptions.Item>
        </Descriptions>
      </Card>
    </div>
  );
};

export default UserDetail;
